export const getInvitesLoading = state => state.invites.areLoading;
export const getInviteCode = state => state.invites.inviteCode;
export const getAcceptedInvites = state => state.invites.accepted;
